<div class="authors">
  <div *ngIf="hasAuthorName(createdBy)" class="author">
    <div>{{ "WXRL.RULE.CREATED_BY" | translate }}</div>
    <div class="author-name">
      {{ getAuthorName(createdBy) }}
    </div>
    <div class="author-date" *ngIf="createdWhen">
      {{ createdWhen | date : "dd/MM/yyyy HH:mm" }}
    </div>
  </div>
  <div *ngIf="shouldShowModified && hasAuthorName(displayModifiedBy)" class="author">
    <div>{{ "WXRL.RULE.LAST_MODIFIED" | translate }}</div>
    <div class="author-name">
      {{ getAuthorName(displayModifiedBy) }}
    </div>
    <div class="author-date" *ngIf="displayModifiedWhen">
      {{ displayModifiedWhen | date : "dd/MM/yyyy HH:mm" }}
    </div>
  </div>
</div>

